export default function showWhatsOnFilter(centreStatus) {
  let shouldDisplay = false;

  if (centreStatus === 'Open') {
    shouldDisplay = true;
  }

  return shouldDisplay;
}